import { CssBaseline, ThemeProvider } from '@mui/material'
import { QueryClientProvider, useQueryClient } from '@tanstack/react-query'
import { BrowserRouter, Navigate, Route, Routes, useNavigate } from 'react-router-dom'
import { queryClient } from './api/queryClient'
import { ME_QUERY_KEY } from './api/session'
import { theme } from './theme'
import { RequireSession } from './components/RequireSession'
import { AiDataPage } from './pages/AiDataPage'
import { AssistantPage } from './pages/AssistantPage'
import { BandsPage } from './pages/BandsPage'
import { UsersPage } from './pages/UsersPage'
import { CompanyProfilePage } from './pages/CompanyProfilePage'
import { DescriptionEditorPage } from './pages/DescriptionEditorPage'
import { HomePage } from './pages/HomePage'
import { JobRecordPage } from './pages/JobRecordPage'
import { JobsPage } from './pages/JobsPage'
import { LoginPage } from './pages/LoginPage'
import { UnitsPage } from './pages/UnitsPage'

/**
 * ADR-0024 D10.1 (LGPD) - REGRA INVIOLAVEL DE ROTEAMENTO:
 * nenhuma rota carrega CPF, e-mail ou nome. Apenas slugs fixos ou identificador
 * opaco. O Application Insights JS coleta a URL da pagina automaticamente.
 *
 * B1 (sessao 35): `/login` fica em tela cheia (padrao Rippling, S31-7); todo o
 * resto passa por `RequireSession`, que monta a casca com o menu lateral e a
 * marca do cliente. A barra de topo do B0 (`AppHeader`) saiu.
 * s55 (R4): a rota `/descricao-ia` (pagina vazia) saiu; quem tiver o endereco salvo cai no `*` -> `/`.
 * s59: `/ia-e-seus-dados` (pagina so de leitura, aberta pelo painel de IA).
 * s63: `/assistente` ("Pergunte ao sistema", ADR-0033 fatia 1, sem IA).
 */

function LoginRoute() {
  const client = useQueryClient()
  const navigate = useNavigate()
  return (
    <LoginPage
      onSignedIn={() => {
        // DESCARTAR, nao so invalidar: um `me = anonimo` guardado de uma visita
        // anterior a "/" seria devolvido na hora pela guarda e mandaria de volta
        // ao login (defeito visto na captura de 29/09; App.test A1-A4).
        client.removeQueries({ queryKey: ME_QUERY_KEY })
        navigate('/', { replace: true })
      }}
    />
  )
}

export function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<LoginRoute />} />
      <Route element={<RequireSession />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/unidades" element={<UnitsPage />} />
        <Route path="/cargos" element={<JobsPage />} />
        <Route path="/cargos/faixas" element={<BandsPage />} />
        <Route path="/cargos/:jobId" element={<JobRecordPage />} />
        <Route path="/cargos/:jobId/descricao" element={<DescriptionEditorPage />} />
        <Route path="/ia-e-seus-dados" element={<AiDataPage />} />
        <Route path="/assistente" element={<AssistantPage />} />
        <Route path="/empresa" element={<CompanyProfilePage />} />
        <Route path="/usuarios" element={<UsersPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  )
}

export function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>
      </QueryClientProvider>
    </ThemeProvider>
  )
}
